import { X } from "lucide-react";
import { IndividualFileChat } from "@/api/models";
import { getFileIcon } from "@/utils/fileValidation";

interface ConversationFilesPanelProps {
  /** Files in the conversation to list. */
  files: IndividualFileChat[];
  /** Whether the panel is toggled open. */
  open: boolean;
  /** Open the given file (SAS URL flow). */
  onOpenFile: (filename: string) => void;
  /** Close the panel. */
  onClose: () => void;
}

/**
 * Conversation-level files panel rendered above the prompt input.
 * Shared by regular Chat and GroupChat so both surface the file list the
 * composer's FileStack toggle controls.
 */
const ConversationFilesPanel = ({ files, open, onOpenFile, onClose }: ConversationFilesPanelProps) => {
  if (!open || files.length === 0) return null;

  const isShare = window.location.pathname.substring(0, 7) === "/share/";

  return (
    <div className="flex flex-wrap justify-between items-center w-[95%] bg-primary bg-opacity-10 rounded-xl gap-2 p-1 mb-1">
      <div className="flex flex-wrap items-center gap-2">
        {files.map((file, idx) => (
          <div
            key={idx}
            className={`flex items-center border border-primary/25 hover:bg-primary hover:bg-opacity-25 rounded-xl ${isShare ? `` : `cursor-pointer`} text-xs gap-1 py-1.5 px-2`}
            onClick={() => { if (!isShare) onOpenFile(file.filename); }}
          >
            <img src={getFileIcon(file.filename)} width="16" />
            {file.filename}
          </div>
        ))}
      </div>
      <button type="button" className="btn btn-sm btn-ghost hover:text-primary px-1" onClick={onClose}>
        <X size={14} />
      </button>
    </div>
  );
};

export default ConversationFilesPanel;
